import {setRegisteredData} from "./registered-data";
import {SCRATCH_TYPE, ScratchCard} from "scratchcard-js";

$(function () {
    const inputs = {
        billNr: $('[name="personal_data[billNr]"]'),
        billDate: $('[name="personal_data[billDate]"]'),
        billPos: $('[name="personal_data[billPos]"]'),
        billNip: $('[name="personal_data[billNip]"]'),
    }

    for (const [key, input] of Object.entries(inputs)) {
        if (input.length) {
            input.closest('.form-group').append(`
<button
  type="button"
  class="btn btn-input-hint-modal"
  data-bs-toggle="modal"
  data-bs-target="#modal-hint-form-application-${key}"
>?</button>`)
        }
    }
})

$('.application-form').on('submit-success', function (event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    const buttonClose = $('#scratch-close'),
        buttonForm = $('#scratch-prize-form-link');

    const prizeId = data.prize === null ? null : data.prize.staticId,
        win = prizeId !== null,
        imageBase = '/images/';
    let backgroundImage = 'scratch-back-lose';

    const scratchCardContainer = $('#modal-scratch-card');

    if (win) {
        $('.result-prize-name').text(data.prize.name);
        $(`.result-prize.prize-${prizeId}`).removeClass('d-none');
        $('#scratch-prize-form-link').prop('href', data.formUrl);

        backgroundImage = 'scratch-back-win';
    }

    $('#modal-form-application')
        .on('shown.bs.modal', function () {
            const scratchCard = new ScratchCard(scratchCardContainer[0], {
                scratchType: SCRATCH_TYPE.LINE,
                containerWidth: scratchCardContainer[0].offsetWidth,
                containerHeight: scratchCardContainer[0].offsetHeight,
                imageForwardSrc: `${imageBase}scratch-front.png`,
                imageBackgroundSrc: `${imageBase}${backgroundImage}.png`,
                clearZoneRadius: 35,
                percentToFinish: 50,
                callback: () => {
                    if (win) {
                        buttonForm.removeClass('d-none');
                        $('#modal-form-application .result-success').removeClass('hidden');
                    } else {
                        buttonClose.removeClass('d-none')
                        $('#modal-form-application .result-failed').removeClass('hidden');
                    }
                }
            })

            scratchCard.init().catch(error => {
                console.log(error)

                scratchCardContainer.html('<h3 class="subheader">Sprawdź, czy uśmiechnęło się do Ciebie szczęście!</h3>')

                $('#scratch-fallback-check').removeClass('d-none').on('click', function() {
                    this.addClass('d-none');

                    if (win) {
                        buttonForm.removeClass('d-none');
                        $('#modal-form-application .result-success').removeClass('hidden');
                    } else {
                        buttonClose.removeClass('d-none')
                        $('#modal-form-application .result-failed').removeClass('hidden');
                    }
                })
            })
        })
        .modal('show');
});

$('input[data-date-start-date], input[data-date-end-date]').on('changeDate', function () {
    let message = null;

    let value = $(this).val();

    const startDate = $(this).data('date-start-date') ? parseRelativeDate($(this).data('date-start-date').split('.').reverse().join('-')) : null,
        endDate = $(this).data('date-end-date') ? parseRelativeDate($(this).data('date-end-date').split('.').reverse().join('-')) : null,
        inputDate = new Date(value.split('.').reverse().join('-'));

    const formatDisplayDate = (date) => Intl.DateTimeFormat('pl-PL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).format(date);

    if ((startDate && startDate.getTime()) || (endDate && endDate.getTime())) {
        if (!value || (startDate && inputDate < startDate) || (endDate && inputDate > endDate)) {
            message = startDate && endDate
                ? `Data musi być z przedziału od ${formatDisplayDate(startDate)} do ${formatDisplayDate(endDate)}`
                : startDate
                    ? `Data nie może być wcześniejsza niż ${formatDisplayDate(startDate)}`
                    : `Data nie może być późniejsza niż ${formatDisplayDate(endDate)}`;
        }
    }

    $(this).siblings('.invalid-feedback').html(message ?? '');
    $(this).parent('.form-group').toggleClass('was-validated', !!message);
})

$('.game-run').on('click', function () {
    // page swap
    $('section#application .page').addClass('d-none');
    $('section#application .page-result').removeClass('d-none').css('display', 'block');

    // modal (uncomment if you need a modal instead of page swap)
    //$('#modal-form-application').modal('show');
});

$('.result-try-again').on('click', function () {
    $('section#application .page').addClass('d-none');
    $('section#application .page-form').removeClass('d-none');
});

$('[name="personal_data[billType]"]').on('change', function () {
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');

/**
 * Calculates date relative to now using simple expressions, like "+1m" or "-1y".
 * If a date is provided, it will be returned as-is.
 *
 * Supported formats:
 *  * d - days
 *  * m - months
 *  * y - years
 *
 * @param {string|Date} input expression to calculate or a date to be returned.
 * @returns {Date}
 * @throws {Error} if the expression is invalid or the unit is not supported.
 */
function parseRelativeDate(input) {
    if (input instanceof Date) return input;
    if (typeof input === "number" || (typeof input === "string" && !isNaN(Date.parse(input)))) {
        const d = new Date(input);
        if (!isNaN(d)) return d;
    }

    const regex = /^([+-])(\d+)([dmy])$/,
        match = (typeof input === "string" ? input.trim() : "").match(regex);
    if (!match) throw new Error(`Invalid date expression: ${input}`);

    const [, sign, amountString, unit] = match,
        amount = parseInt(amountString, 10) * (sign === "-" ? -1 : 1),
        date = new Date();

    switch (unit.toLowerCase()) {
        case "y":
            date.setFullYear(date.getFullYear() + amount);
            break;
        case "m":
            date.setMonth(date.getMonth() + amount);
            break;
        case "d":
            date.setDate(date.getDate() + amount);
            break;
        default:
            throw new Error(`Unsupported date unit: ${unit}`);
    }

    return date;
}
